import React from 'react'
import './TitleLabel.styles.sass'
const TitleLabel = (props: any) => {
    return (
        <div className="signInText"> {props.label}</div>
    )
}

export default TitleLabel